export interface ScrollInterface {
  lastPosition: number;
  atTop: boolean;
  up: boolean;
  down: boolean;
  scrollUpdate(): void;
}

const Scroll = (): ScrollInterface => ({
  lastPosition: 0,
  atTop: true,
  up: false,
  down: false,

  /**
   * Update the scroll states (atTop, up & down).
   */
  scrollUpdate(): void {
    const element = document.documentElement;

    const drupalDisplaceOffset =
      parseInt(
        window
          .getComputedStyle(element)
          .getPropertyValue('--drupal-displace-offset-top'),
        10,
      ) || 0;

    const currentOffset = element.scrollTop;
    this.atTop = currentOffset === 0;

    if (currentOffset > drupalDisplaceOffset) {
      this.up = currentOffset < this.lastPosition;
      this.down = currentOffset >= this.lastPosition;
      this.lastPosition = currentOffset;
    }
  },
});

export default Scroll;
